/* eslint-ignore */
// @ts-nocheck
import React from "react";

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TooltipFormated,
  TootipTitle,
} from "./styles";

const CustomTooltipMobile: React.FC = () => {
  return (
    <Container>
      <TooltipContainer>
        <TootipTitle>Endereço de correspondência</TootipTitle>
        <TolltipItens />
        Atualize o endereço de correspondência no menu Boletos, em
        <TooltipFormated to="/preferencia-cobranca">
          Preferências de cobrança.
        </TooltipFormated>
      </TooltipContainer>
    </Container>
  );
};

export default CustomTooltipMobile;
